(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewProfile.controller:OtherHubEditDialogCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('crewProfile').controller('otherHubEditCtrl',
			otherHubEditCtrl);

	function otherHubEditCtrl($uibModalInstance, modalParams, ProfileService,
			MessageService, EventManagerService) {
		var vm = this;
		vm.ctrlName = 'otherHubEditCtrl';
		vm.selectedRowBeforeUpdate = angular.copy(modalParams.selectedRow);
		vm.manualClients = modalParams.masterList.manualClients || [];
		vm.autoImportClients = modalParams.masterList.autoImportClients || [];
		vm.model = {
			selectedHoursData : adaptOtherHubHourData(),
			masterList : {
				clients : getRelavantClientList()
			},
			fromDateAfterToDate : false,
			importForFuture : false,
			manualImportNotWithinMonth : false
		};

		function adaptOtherHubHourData() {
			vm.selectedRowBeforeUpdate.flyingHoursInHHMI = getAdaptedHour(vm.selectedRowBeforeUpdate.flyingHoursInHHMI);
			vm.selectedRowBeforeUpdate.dutyHoursInHHMI = getAdaptedHour(vm.selectedRowBeforeUpdate.dutyHoursInHHMI);
			vm.selectedRowBeforeUpdate.carrier = selectCarrierFromList(
					vm.selectedRowBeforeUpdate.carrierCode,
					getRelavantClientList());
			return angular.copy(vm.selectedRowBeforeUpdate);
		}
		;

		function selectCarrierFromList(carrierCode, list) {
			if (!!carrierCode && !!list) {
				return _.find(list, {
					hubCode : carrierCode
				});
			}
			return null;
		}
		;

		// this is done to set the value to the place holder with 3 values for
		// hour part
		function getAdaptedHour(hoursInHHMI) {
			var hoursInHHHMI = "000:00";
			if (!!hoursInHHMI) {
				if (hoursInHHMI.length < 5) {
					return hoursInHHHMI = '00' + angular.copy(hoursInHHMI);
				} else if (hoursInHHMI.length < 6) {
					return hoursInHHHMI = '0' + angular.copy(hoursInHHMI);
				}
			}
			return hoursInHHMI;
		}

		function getRelavantClientList() {
			if (!!vm.selectedRowBeforeUpdate) {
				if (vm.selectedRowBeforeUpdate.autoImport) {
					return vm.autoImportClients;
				} else {
					return vm.manualClients;
				}
			}
			return [];
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.selectedHoursData.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.selectedHoursData.fromDate,
									"DD/MM/YYYY"));
		}
		;

		function isFutureDate(date) {
			return moment().isBefore(moment(date, "DD/MM/YYYY"));
		}
		;

		function isImportRecordWithinMultipleMonth() {
			if (!isDateFormatInvalid(vm.model.selectedHoursData.fromDate)
					&& !isDateFormatInvalid(vm.model.selectedHoursData.toDate)
					&& !vm.model.fromDateAfterToDate
					&& !vm.model.importForFuture
					&& moment(vm.model.selectedHoursData.fromDate, "DD/MM/YYYY")
							.format("MM/YYYY") !== moment(
							vm.model.selectedHoursData.toDate, "DD/MM/YYYY")
							.format("MM/YYYY")) {
				return true;
			}
			return false;
		}
		;

		function isImportForFuture() {
			if (!isDateFormatInvalid(vm.model.selectedHoursData.fromDate)
					&& !isDateFormatInvalid(vm.model.selectedHoursData.toDate)
					&& !vm.model.fromDateAfterToDate
					&& (isFutureDate(vm.model.selectedHoursData.fromDate) || isFutureDate(vm.model.selectedHoursData.toDate))) {
				return true;
			}
			return false;
		}

		vm.changeField = function(flag) {
			if (flag == 'fromDate') {
				var tempFromDate = moment(vm.model.selectedHoursData.fromDate,
						"DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
				vm.model.selectedHoursData.toDate = tempFromDate;
			}
			if (!isDateFormatInvalid(vm.model.selectedHoursData.fromDate)
					&& !isDateFormatInvalid(vm.model.selectedHoursData.toDate)) {
				vm.model.fromDateAfterToDate = istoDateBeforeFromDate();
				vm.model.importForFuture = isImportForFuture();
				vm.model.manualImportNotWithinMonth = isImportRecordWithinMultipleMonth();
			} else {
				vm.model.fromDateAfterToDate = false;
				vm.model.importForFuture = false;
				vm.model.manualImportNotWithinMonth = false;
			}
		};

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}
		;

		function getSaveOtherHubRequest(hoursDTO) {
			var req = {};
			req.fromDate = hoursDTO.fromDate;
			req.toDate = hoursDTO.toDate;
			req.flyingHoursInMins = ProfileService.convertToMinutes(angular
					.copy(hoursDTO.flyingHoursInHHMI));
			req.dutyHoursInMins = ProfileService.convertToMinutes(angular
					.copy(hoursDTO.dutyHoursInHHMI));
			req.hoursDetailsChange = getHourDetailChange(hoursDTO);
			req.carrierCode = hoursDTO.carrier.hubCode;
			req.crewHubFlyingHoursId = hoursDTO.crewHubFlyingHoursId;
			req.version = hoursDTO.version;
			req.crewProfileId = hoursDTO.crewProfileId;
			req.autoImport = hoursDTO.autoImport;
			return req;
		}

		function getHourDetailChange(hoursDTO) {
			if (vm.model.selectedHoursData.flyingHoursInHHMI === vm.selectedRowBeforeUpdate.flyingHoursInHHMI
					&& vm.model.selectedHoursData.dutyHoursInHHMI === vm.selectedRowBeforeUpdate.dutyHoursInHHMI
					&& vm.model.selectedHoursData.fromDate === vm.selectedRowBeforeUpdate.fromDate
					&& vm.model.selectedHoursData.toDate === vm.selectedRowBeforeUpdate.toDate
					&& ((!!vm.model.selectedHoursData.carrier
							&& !!vm.selectedRowBeforeUpdate.carrier && vm.model.selectedHoursData.carrier.hubCode === vm.selectedRowBeforeUpdate.carrier.hubCode))
					|| vm.model.selectedHoursData.carrier == vm.selectedRowBeforeUpdate.carrier) {
				return false;
			}
			return true;
		}

		vm.saveUpdateOtherHubHours = function(hoursDTO) {
			vm.otherHubForm.$submitted = true;
			vm.model.fromDateAfterToDate = istoDateBeforeFromDate();
			vm.model.importForFuture = isImportForFuture();
			vm.model.manualImportNotWithinMonth = isImportRecordWithinMultipleMonth();
			if (isValidSelectedHoursData()) {
				var param = getSaveOtherHubRequest(hoursDTO);
				ProfileService
						.saveHoursData(
								param,
								function(response) {
									if (response.success) {
										MessageService
												.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
										vm.onCloseClick();
										EventManagerService
												.notifyEventListeners(
														EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.SEARCH,'M');
									}
								}, function(error) {
									MessageService.error(error);
								});
			}
		};

		function isValidSelectedHoursData() {
			if (vm.otherHubForm.$valid
					&& vm.model.selectedHoursData.carrier.hubCode !== ''
					&& !vm.model.fromDateAfterToDate
					&& !vm.model.importForFuture
					&& !vm.model.manualImportNotWithinMonth) {
				return true;
			}
			return false;
		}

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

	}
}());
